import { OperatorsEnum } from '@celito.clients/enums';
import { RulesComponentListViewFilter } from 'libs/shared/src/lib/rules-component/types/rules-component.types';

export const userViewDefaultFilter: RulesComponentListViewFilter = {
  conditions: {
    all: [
      {
        all: [
          {
            attribute: 'isActive',
            operator: OperatorsEnum.EQUALS,
            value: true,
          },
        ],
      },
    ],
  },
};
